import { StoreState } from "./index";

export function getReferralResponse(state: StoreState): StoreState["referral"] {
  return state.referral;
}

export function getQR(state: StoreState): StoreState["qr"] {
  return state.qr;
}

export function getIsLoadingReferral(
  state: StoreState
): StoreState["isLoading"]["referral"] {
  return state.isLoading.referral;
}

export function getIsLoadingQR(
  state: StoreState
): StoreState["isLoading"]["qr"] {
  return state.isLoading.qr;
}

export function getQRError(state: StoreState): StoreState["error"]["qr"] {
  return state.error.qr;
}

export function getIsLoadingGoogleWallet(
  state: StoreState
): StoreState["isLoading"]["googleWallet"] {
  return state.isLoading.googleWallet;
}

export function getGoogleWalletError(
  state: StoreState
): StoreState["error"]["googleWallet"] {
  return state.error.googleWallet;
}

export function getGoogleWalletResponse(
  state: StoreState
): StoreState["googleWallet"] {
  return state.googleWallet;
}

export function getIsLoadingAppleWallet(
  state: StoreState
): StoreState["isLoading"]["appleWallet"] {
  return state.isLoading.appleWallet;
}

export function getAppleWalletError(
  state: StoreState
): StoreState["error"]["appleWallet"] {
  return state.error.appleWallet;
}

export function getAppleWalletResponse(
  state: StoreState
): StoreState["appleWallet"] {
  return state.appleWallet;
}
